import { Typography } from '@vp/swan'
import { TileGreetingOptionsProps } from '~/client/components/common/TileGreetingOptions/interface'

export const TileGreetingOptions = ({ children }: TileGreetingOptionsProps) => (
  <Typography className="tile-greeting-options" fontSize="small">
    {children}
  </Typography>
)
